import React from "react";
import { useEffect, useState } from 'react';
import { Form, Button, Table, Col, Row, Container, Card } from 'react-bootstrap';
import { capitalizeFirstLetter, CharacterCount, validateRecords } from '../Shared/Helpers';
import { v4 as uuidv4 } from 'uuid';
import { isEmpty } from "lodash";
import SweetAlert from "react-bootstrap-sweetalert";
import ReactDatetime from "react-datetime";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import DateSelect from "../../Shared/DateSelect";
import { getDateInInput } from "../../../utils/FormatDate";

const EqualOpportunitiesMonitoring = ({ handleSubmit, handleBack, storedData, stepNum }) => {

    // STATES
    const [showAlert, setShowAlert] = useState(false);
    const [errors, setErrors] = useState({});
    const [gender, setGender] = useState('');
    const [ageGroup, setAgeGroup] = useState('');
    const [sameSexSinceBirth, setSameSexSinceBirth] = useState('');
    const [ethnicityBackground, setEthnicityBackground] = useState('');
    const [nationality, setNationality] = useState('');
    const [sexualOrientation, setSexualOrientation] = useState('');
    const [religionGroup, setReligionGroup] = useState('');
    const [religion, setReligion] = useState('');
    const [selectedDisability, setSelectedDisability] = useState(null);
    const [hasDisability, setHasDisability] = useState('');
    const [religionID, setReligionID] = useState('');
    const [dOB, setDOB] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [dataConsent, setDataConsent] = useState(false);
    const [alert, setAlert] = React.useState(null);
    const hideAlert = () => setAlert(null);

    const handleDataConsentChange = (e) => {
        setDataConsent(e.target.checked);
    };
    // please specify options here
    const [other, setOther] = useState({
        gender: '',
        ethnicityBackground: '',
        sexualOrientation: '',
        religion: '',
        disability: '',
    });


    const handleBackButton = () => {
        const dataToSave = {
            gender,
            ageGroup,
            sameSexSinceBirth,
            ethnicityBackground,
            nationality,
            sexualOrientation,
            religionGroup,
            religion,
            selectedDisability,
            hasDisability,
            religionID,
            dOB
        };
        handleBack(dataToSave);
    };

    const handleChange = selectedDisability => {
        setSelectedDisability(selectedDisability);
        setErrors({ ...errors, selectedDisability: '' });
    };

    function handleDateChange(date) {
        const formattedDate = date.format("DD/MM/YYYY");
        setDOB(formattedDate);
    }

    function validateForm() {

        return {
            gender: isEmpty(gender) && 'Gender is required',
            genderOther: gender === "Other" && isEmpty(other.gender) ? 'Please specify Gender' : '',
            ageGroup: isEmpty(ageGroup) && 'Age Group Selection is required',
            sameSexSinceBirth: isEmpty(sameSexSinceBirth) && 'This question requires a selection',
            ethnicityBackground: isEmpty(ethnicityBackground) && 'Ethnicity Selection is required',
            ethnicityOther: ethnicityBackground && ethnicityBackground.toLowerCase().includes('other') && isEmpty(other.ethnicityBackground) ? 'Please provide more detail about ethnicity background' : '',
            nationality: isEmpty(nationality) && 'Nationality is required',
            sexualOrientation: isEmpty(sexualOrientation) && 'Sexual Orientation Selection is required',
            sexualOrientationOther: sexualOrientation === 'Prefer to self-describe' && isEmpty(other.sexualOrientation) ? 'Please Describe Sexual Orientation' : '',
            religion: isEmpty(religion) && 'Religion Selection is required',
            religionOther: religion && religion.toLowerCase().includes('other') && isEmpty(other.religion) ? 'Please specify religion' : '',
            hasDisability: isEmpty(hasDisability) && 'This question requires a selection',
            selectedDisability: hasDisability === "Yes" && isEmpty(selectedDisability) ? 'Please select a option from the dropdown' : '',
            DOB: !dOB || new Date(dOB) > new Date() ? 'Please enter a valid DOB.' : null
            /*     disabilityOther: hasDisability === "Yes" && selectedDisability === "Other" && isEmpty(other.disability) ? 'Please specify disability' : '',*/
        };
    }


    const handleSubmitCommand = async () => {
        try {

            setIsLoading(true);
            const logErrors = validateForm();

            if (!Object.values(logErrors).some(Boolean)) {
                setErrors([]);

                let selectedDisabilityString = ''; // declare variable outside if block

                if (selectedDisability) {
                    const selectedDisabilityValues = selectedDisability.map(option => option.value);
                    selectedDisabilityString = selectedDisabilityValues.join(' - ');
                }

                const equalOpportunitiesDetails = {
                    Gender: gender === "Other" ? `Other - ${other.gender}` : gender,
                    AgeGroup: ageGroup,
                    SameSexSinceBirth: sameSexSinceBirth,
                    EthnicityBackground: ethnicityBackground.toLowerCase().includes('other') ? religionGroup + " - " + `Other - ${other.ethnicityBackground}` : religionGroup + " - " + ethnicityBackground,
                    Nationality: nationality,
                    SexualOrientation: sexualOrientation === "Prefer to self-describe" ? `Other - ${other.sexualOrientation}` : sexualOrientation,
                    HasDisability: hasDisability === "Yes" ? true : false,
                    DisabilityDetails: hasDisability === "Yes" ? selectedDisabilityString + (other.disability ? ` - ${other.disability}` : '') : null,
                    ReligionOrBelief: religion.toLowerCase().includes('other') ? `Other - ${other.religion}` : religion,
                    DOB: dOB,
                    ReligionID: religionID
                };


                if (!dataConsent) {
                    setAlert(
                        <SweetAlert
                            warning
                            style={{ display: "block", marginTop: "-100px" }}
                            title="Error"
                            onConfirm={() => hideAlert()}
                            onCancel={() => hideAlert()}
                            confirmBtnBsStyle="info"
                        >
                            You must agree to the processing of your Personal Data before submitting
                        </SweetAlert>
                    );
                    setIsLoading(false);
                    return;
                }

                // confirm before submit
                setAlert(
                    <SweetAlert
                        warning
                        style={{ display: "block", marginTop: "-100px" }}
                        title="Submission Confirmation"
                        onConfirm={() => {
                            handleSubmit(equalOpportunitiesDetails);
                            hideAlert();
                        }}
                        onCancel={() => {
                            setIsLoading(false);
                            hideAlert();
                        }}
                        confirmBtnBsStyle="info"
                        cancelBtnBsStyle="danger"
                        cancelBtnCssClass="danger"
                        showCancel
                    >
                        You are about to submit your application. Please click ok to confirm.
                    </SweetAlert>
                );

            }
            else {
                setErrors(logErrors);
                window.scrollTo(0, 0);
                setIsLoading(false);
            }
        }
        catch (e) {
            console.log(e);
        }
    }


    //### HOOKS ### 
    useEffect(() => {
        const stateToUpdate = {

            // Clear data if selecting new item
            religion: () => religion !== 'Other – please specify' && setOther({ ...other, religion: '' }),
            sexualOrientation: () => sexualOrientation !== 'Prefer to self-describe' && setOther({ ...other, sexualOrientation: '' }),
            ethnicityBackground: () => ethnicityBackground !== 'Other' && setOther({ ...other, ethnicityBackground: '' }),
            gender: () => gender !== 'Other' && setOther({ ...other, gender: '' }),
            hasDisability: () => {
                if (hasDisability !== 'Yes') {
                    setSelectedDisability([]);
                    setOther({ ...other, disability: '' })
                }
            },
        };

        Object.values(stateToUpdate).forEach(fn => fn());
    }, [religion, sexualOrientation, ethnicityBackground, gender, hasDisability]);


    useEffect(() => {
        // stores the data between the steps
        window.scrollTo(0, 0)

        if (storedData && Object.keys(storedData).length > 0) {


            console.log('po', storedData);
            // Assuming savedData is an object containing the data
            setGender(storedData?.gender || '');
            setAgeGroup(storedData?.ageGroup || '');
            setSameSexSinceBirth(storedData?.sameSexSinceBirth || '');
            setEthnicityBackground(storedData?.ethnicityBackground || '');
            setNationality(storedData?.nationality || '');
            setSexualOrientation(storedData?.sexualOrientation || '');
            setReligionGroup(storedData?.religionGroup || '');
            setReligion(storedData?.religion || '');
            setSelectedDisability(storedData?.selectedDisability || null);
            setHasDisability(storedData?.hasDisability || '');

        } else {
            console.log("storedData is empty");
        }
    }, []);


    return (
        <Row>
            {alert}



            <Col sm={12} md={12}>
                <h2 >{stepNum} Equal Opportunities Monitoring Form</h2>
                <h5 style={{ fontWeight: 'normal', fontSize: '0.99rem', textAlign: 'justify' }}>
                    FP McCann are an Equal Opportunities Employer and want to meet the
                    aims and commitments set out in our Equal Opportunity Policy. We will not
                    discriminate unfairly against any individual on the grounds of perceived
                    religious or political affiliation, sexual orientation, gender, gender
                    reassignment, marital status, age, civil partnerships, having or not having
                    dependents, disability, colour, race or ethnic or national origins, pregnancy &
                    maternity, or membership of the Irish Traveller community. We practice
                    equality of opportunity in employment and select the best person for the job.
                </h5>

                <h5 style={{ fontWeight: 'normal', fontSize: '0.99rem', textAlign: 'justify' }}>
                    The organisation needs your help and co-operation in building an accurate
                    picture of the make-up of our workforce. The information provided will be kept
                    confidential and will be used for monitoring purposes.
                </h5>
            </Col>

            <Col sm={6} md={12} className="my-0 custom-dashed"></Col>

            <Col sm={12} md={6} className="my-1">
                <h5>Gender:<span className="star">*</span></h5>
                <div style={{ position: 'relative', width: '100%' }}>
                <select
                    id="title-select"
                    name="title"
                    className={errors.gender ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    value={gender}
                    onChange={(e) => {
                        setGender(e.target.value);
                        setErrors({ ...errors, gender: '' });
                    }}>
                    <option value="">-Please Select-</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Intersex">Intersex</option>
                    <option value="Non-binar">Non-binary</option>
                    <option value="Prefer not to say">Prefer not to say</option>
                    <option value="Other">Prefer to self-describe</option>
                    </select>
                    <div style={{ position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                        &#9660;
                    </div>
                </div>
                {errors.gender && <Form.Text className="text-danger"> <span className="star">*</span> {errors.gender} </Form.Text>}
            </Col>

            <Col sm={12} md={6} className="my-1">
                <h5>Please specify:</h5>
                <Form.Group>
                    <Form.Control
                        disabled={gender !== "Other"}
                        className={errors.genderOther ? "form-control is-invalid custom-input" : "form-control custom-input"}
                        value={other.gender}
                        onChange={(e) => {
                            setOther({ ...other, gender: e.target.value });
                            setErrors({ ...errors, genderOther: '' });
                        }}
                        type="text"
                        maxLength="100"
                    />
                </Form.Group>
                {errors.genderOther && <Form.Text className="text-danger"> <span className="star">*</span> {errors.genderOther} </Form.Text>}
            </Col>


            <Col sm={12} md={6} className="my-1">
                <h5>Is the gender you identify with the same as your gender registered at birth?:<span className="star">*</span></h5>
                <div style={{ position: 'relative', width: '100%' }}>
                <select
                    id="title-select"
                    name="genderSameBirth"
                    className={errors.sameSexSinceBirth ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    value={sameSexSinceBirth}
                    onChange={(e) => {
                        setSameSexSinceBirth(e.target.value);
                        setErrors({ ...errors, sameSexSinceBirth: '' });
                    }}>
                    <option value="">-Please Select-</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    <option value="Prefer not to say">Prefer not to say </option>
                    </select>
                    <div style={{ position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                        &#9660;
                    </div>
                </div>
                {errors.sameSexSinceBirth && <Form.Text className="text-danger"> <span className="star">*</span> {errors.sameSexSinceBirth} </Form.Text>}
            </Col>


            <Col sm={12} md={6} className="my-1">
                <h5 style={{paddingBottom: "18px"}}>Date of Birth:<span className="star">*</span></h5>
                <Form.Group>
                    {/*<ReactDatetime*/}
                    {/*    inputProps={{*/}
                    {/*        className: errors.DOB ? "form-control is-invalid custom-input" : "form-control custom-input",*/}
                    {/*        name: "contact",*/}
                    {/*        disabled: false*/}
                    {/*    }}*/}
                    {/*    defaultValue={new Date()}*/}
                    {/*    timeFormat={false}*/}
                    {/*    dateFormat="DD/MM/YYYY"*/}
                    {/*    value={dOB}*/}
                    {/*    onChange={handleDateChange}*/}
                    {/*/>*/}
                    <DateSelect
                        withSteppers={false}
                        value={dOB}
                        handleChange={handleDateChange}
                        error={errors.DOB}
                    />
                </Form.Group>
                {errors.DOB && <Form.Text className="text-danger"> <span className="star">*</span> {errors.DOB} </Form.Text>}
            </Col>

            <Col sm={12} md={6} className="my-1">
                <h5>Age Group:<span className="star">*</span></h5>
                <div style={{ position: 'relative', width: '100%' }}>
                <select
                    id="title-select"
                    name="title"
                    value={ageGroup}
                    className={errors.ageGroup ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    onChange={(e) => {
                        setAgeGroup(e.target.value)
                        setErrors({ ...errors, ageGroup: '' });

                    }}
                >
                    <option value="">-Please Select-</option>
                    <option value="16-24">16-24</option>
                    <option value="25-29">25-29</option>
                    <option value="30-34">30-34 </option>
                    <option value="35-39">35-39</option>
                    <option value="40-44">40-44</option>
                    <option value="45-49">45-49</option>
                    <option value="50-54">50-54</option>
                    <option value="55-59">55-59</option>
                    <option value="60-64">60-64</option>
                    <option value="65+">65+</option>
                    <option value="Prefer not to say">Prefer not to say</option>
                </select>
                    <div style={{ position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                        &#9660;
                    </div>
                </div>
                {errors.ageGroup && <Form.Text className="text-danger"> <span className="star">*</span> {errors.ageGroup} </Form.Text>}
            </Col>



            <Col sm={12} md={6} className="my-1">
                <h5>What is your nationality?:<span className="star">*</span></h5>
                <Form.Group>
                    <Form.Control
                        className={errors.nationality ? "form-control is-invalid custom-input" : "form-control custom-input"}
                        value={nationality}
                        onChange={(e) => {
                            setNationality(e.target.value);
                            setErrors({ ...errors, nationality: '' });
                        }}
                        maxLength="100"
                        type="text" />
                </Form.Group>
                {errors.nationality && <Form.Text className="text-danger"> <span className="star">*</span> {errors.nationality} </Form.Text>}
            </Col>


            <Col sm={12} md={12} className="my-1">
                <h5>Religious Background: </h5>

                <div style={{ position: 'relative', width: '100%' }}>
                    <select
                        id="title-select"
                        name="title"
                        value={religionID}
                        className="form-control custom-input"
                        onChange={(e) => {
                            setReligionID(e.target.value)
                        }}
                        style={{ paddingRight: '30px' }} // Adjust the padding to make room for the arrow
                    >
                        <option value=""></option>
                        <option value="Catholic">Catholic</option>
                        <option value="Protestant">Protestant</option>
                        <option value="Neither">Neither</option>
                    </select>
                    <div style={{ position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                        &#9660;
                    </div>
                </div>

                <h5 style={{ fontWeight: 'normal', fontSize: '0.99rem', textAlign: 'justify' }}>
                    <span className="star">*</span> If you do not answer the above question, we are encouraged to use the residuary method if making a determination, which means that we can make a determination as to your community background on the basis of the personal information supplied by you in your application form/ personnel file.
                </h5>
            </Col>



            <Col sm={6} md={12} className="my-0 custom-dashed"></Col>
            <Col sm={12} md={12} className="my-0">
                <div >
                    <h2 style={{ textAlign: 'left', fontSize: '18px' }}>What is your ethnicity?</h2>
                    <h5 style={{ fontWeight: 'normal', fontSize: '0.99rem', textAlign: 'justify' }}>
                        Ethnic origin is not about nationality, place of birth or citizenship. It is about the group to which you perceive you belong. Please select from the options below:<span className="star">*</span></h5>
                </div>
            </Col>

            <Col sm={12} md={6} className="my-1">
                <h5>Please Select Ethnicity:<span className="star">*</span></h5>
                <div style={{ position: 'relative', width: '100%' }}>
                <select
                    id="title-select" name="title"
                    className={errors.ethnicityBackground ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    value={ethnicityBackground}
                    onChange={(e) => {
                        const selectedValue = e.target.value;
                        const selectedGroup = e.target.options[e.target.selectedIndex].parentNode.label;
                        setReligionGroup(selectedGroup);
                        setEthnicityBackground(selectedValue);
                        setErrors({ ...errors, ethnicityBackground: "" });

                        // You can perform additional actions based on the selected group
                    }}
                >
                    <option value="">-Please Select-</option>
                    <optgroup label="Asian or Asian British">
                        <option value="Bangladeshi">Bangladeshi</option>
                        <option value="Chinese">Chinese</option>
                        <option value="Indian">Indian</option>
                        <option value="Other Asian background">Other Asian background</option>
                        <option value="Pakistani">Pakistani</option>
                        <option value="Prefer not to say">Prefer not to say</option>
                    </optgroup>
                    <optgroup label="Black, African, Caribbean or Black British">
                        <option value="African">African</option>
                        <option value="Caribbean">Caribbean</option>
                        <option value="Other Black, African or Caribbean background">Other Black, African or Caribbean background</option>
                        <option value="Prefer not to say">Prefer not to say</option>
                    </optgroup>
                    <optgroup label="Mixed or Multiple ethnic groups">
                        <option value="Other Mixed or Multiple ethnic background">Other Mixed or Multiple ethnic background</option>
                        <option value="White and African">White and African</option>
                        <option value="White and Asian">White and Asian</option>
                        <option value="White and Black African">White and Black African</option>
                        <option value="White and Black Caribbean">White and Black Caribbean</option>
                        <option value="Prefer not to say">Prefer not to say</option>
                    </optgroup>
                    <optgroup label="White">
                        <option value="British">British</option>
                        <option value="English">English</option>
                        <option value="Irish Traveller">Irish Traveller</option>
                        <option value="Irish">Irish</option>
                        <option value="Northern Irish">Northern Irish</option>
                        <option value="Other White background">Other White background</option>
                        <option value="Scottish">Scottish</option>
                        <option value="Welsh">Welsh</option>
                        <option value="Prefer not to say">Prefer not to say</option>
                    </optgroup>
                    <optgroup label="Other Ethnic Group / Options">
                        <option value="Arab">Arab</option>
                        <option value="Other">Other</option>
                        <option value="Prefer not to say">Prefer not to say</option>
                    </optgroup>

                    </select>
                    <div style={{ position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                        &#9660;
                    </div>
                </div>
                {errors.ethnicityBackground && <Form.Text className="text-danger"> <span className="star">*</span> {errors.ethnicityBackground} </Form.Text>}
            </Col>


            <Col sm={12} md={6} className="my-1">
                <h5>Please specify:</h5>
                <Form.Group>
                    <Form.Control
                        className={errors.ethnicityOther ? "form-control is-invalid custom-input" : "form-control custom-input"}
                        disabled={ethnicityBackground.includes("Other") ? false : true}
                        value={other.ethnicityBackground}
                        maxLength="250"
                        onChange={(e) => {
                            setOther({ ...other, ethnicityBackground: e.target.value });
                            setErrors({ ...errors, ethnicityOther: '' });
                        }}
                        type="text" />
                </Form.Group>
                {errors.ethnicityOther && <Form.Text className="text-danger"> <span className="star">*</span> {errors.ethnicityOther} </Form.Text>}
            </Col>


            <Col sm={6} md={12} className="my-0 custom-dashed"></Col>

            {/*<Col sm={12} md={12} className="my-0">*/}
            {/*    <div >*/}
            {/*        <h2 style={{ textAlign: 'left', fontSize: '18px' }}>What is your nationality?</h2>*/}
            {/*    </div>*/}

            {/*    <Col sm={12} md={6} className="my-1">*/}
            {/*        <h5>Please specify:</h5>*/}
            {/*        <Form.Group>*/}
            {/*            <Form.Control*/}
            {/*                className="form-control custom-input"*/}
            {/*                type="text" />*/}
            {/*        </Form.Group>*/}
            {/*    </Col>*/}
            {/*</Col>*/}

            {/*   <Col sm={6} md={12} className="my-0 custom-dashed"></Col>*/}



            <Col sm={12} md={12} >
                <h2 style={{ textAlign: 'left', fontSize: '18px' }}>Do you consider yourself to have a disability or health condition?</h2>
                <h5 style={{ fontWeight: 'normal', fontSize: '0.99rem' }}>Under the Disability Discrimination Act 1995, a person is deemed to be disabled if they
                    have a physical or mental impairment which has a substantial and long-term adverse
                    effect on their ability to carry out normal day-to-day activities. Please note it is the effect
                    of the impairment without treatment which determines whether an individual meets the
                    definition.</h5>
            </Col>

            <Col sm={12} md={6} className="my-1">
                <h5>Do you consider that you are a disabled person?:<span className="star">*</span></h5>
                <div style={{ position: 'relative', width: '100%' }}>
                <select
                    id="title-select"
                    name="title"
                    value={hasDisability}
                    className={errors.hasDisability ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    onChange={(e) => {
                        setHasDisability(e.target.value);
                        setErrors({ ...errors, hasDisability: '' });
                    }}
                >
                    <option value="">-Please Select-</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    <option value="Prefer not to say">Prefer not to say</option>
                </select>
                <div style={{ position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                    &#9660;
                </div>
            </div>
                {errors.hasDisability && <Form.Text className="text-danger"> <span className="star">*</span> {errors.hasDisability} </Form.Text>}
            </Col>


            {hasDisability === "Yes" && (
                <>
                    <Col sm={6} md={6}></Col>
                    <Col sm={6} md={6} className="my-1">
                        <h5>If you have answered yes, please indicate the nature of your impairment:</h5>
                        <Select
                            value={selectedDisability}
                            onChange={handleChange}
                            options={[
                                {
                                    label: 'Physical Impairment', options: [
                                        { value: 'Difficulty using your arms', label: 'Difficulty using your arms' },
                                        { value: 'Mobility issues requiring you to use a wheelchair or crutches', label: 'Mobility issues requiring you to use a wheelchair or crutches' },
                                        { value: 'Other – please specify', label: 'Other – please specify' },
                                    ]
                                },
                                {
                                    label: 'Sensory Impairment', options: [
                                        { value: 'Blindness or serious visual impairment', label: 'Blindness or serious visual impairment' },
                                        { value: 'Deaf or serious hearing impairment', label: 'Deaf or serious hearing impairment' },
                                        { value: 'Other – please specify', label: 'Other – please specify' },
                                    ]
                                },
                                {
                                    label: 'Mental health condition', options: [
                                        { value: 'Depression', label: 'Depression' },
                                        { value: 'Schizophrenia', label: 'Schizophrenia' },
                                        { value: 'Other – please specify', label: 'Other – please specify' },
                                    ]
                                }
                                ,
                                {
                                    label: 'Learning disability/difficulty', options: [
                                        { value: 'Downs Syndrome', label: 'Downs Syndrome' },
                                        { value: 'Dyslexia', label: 'Dyslexia' },
                                        { value: 'Other – please specify', label: 'Other – please specify' },
                                    ]
                                }
                                ,
                                {
                                    label: 'Cognitive impairment', options: [
                                        { value: 'Autism', label: 'Autism' },
                                        { value: 'Other – please specify', label: 'Other – please specify' },
                                    ]
                                },
                                ,
                                {
                                    label: 'Long standing or progressive illness', options: [
                                        { value: 'Cancer', label: 'Cancer' },
                                        { value: 'HIV infection', label: 'HIV infection' },
                                        { value: 'Diabetes', label: 'Diabetes' },
                                        { value: 'Epilepsy', label: 'Epilepsy' },
                                        { value: 'Chronic heart disease', label: 'Chronic heart disease' },
                                        { value: 'Other – please specify', label: 'Other – please specify' },
                                    ]
                                },
                                ,
                                {
                                    label: 'Other', options: [
                                        { value: 'Other', label: 'Other' }
                                    ]
                                }
                            ]}
                            isMulti
                            placeholder="-Please Select-"
                        />
                        {errors.selectedDisability && <Form.Text className="text-danger"> <span className="star">*</span> {errors.selectedDisability} </Form.Text>}
                    </Col>


                    <Col sm={6} md={6} className="my-1">
                        <h5>Please specify other disability if not listed:</h5>
                        <Form.Group>
                            <Form.Control
                                maxLength="1000"
                                className="form-control custom-input"
                                value={other.disability}
                                onChange={(e) => {
                                    setOther({ ...other, disability: e.target.value });
                                    /*     setErrors({ ...errors, disabilityOther: '' });*/
                                }}
                                type="text" />
                        </Form.Group>
                        {/*           {errors.disabilityOther && <Form.Text className="text-danger"> <span className="star">*</span> {errors.disabilityOther} </Form.Text>}*/}
                    </Col>
                </>
            )}

            <Col sm={6} md={12} className="my-1">
                <h5 style={{ fontWeight: 'normal', fontSize: '0.99rem' }}>
                    The information in this form is for monitoring purposes only. If you believe you need a
                    ‘reasonable adjustment’, then please discuss this with the manager running the
                    recruitment process if you are a job applicant.</h5>
            </Col>


            <Col sm={6} md={12} className="my-0 custom-dashed"></Col>

            <Col sm={12} md={6} className="my-1">
                <h5>What is your sexual orientation?:<span className="star">*</span></h5>
                <div style={{ position: 'relative', width: '100%' }}>
                <select
                    id="title-select"
                    name="title"
                    className={errors.sexualOrientation ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    value={sexualOrientation}
                    onChange={(e) => {
                        setSexualOrientation(e.target.value);
                        setErrors({ ...errors, sexualOrientation: '' });
                    }}
                >
                    <option value="">-Please Select-</option>
                    <option value="Heterosexual">Heterosexual</option>
                    <option value="Gay">Gay</option>
                    <option value="Lesbian">Lesbian</option>
                    <option value="Bisexual">Bisexual</option>
                    <option value="Asexual">Asexual</option>
                    <option value="Pansexual">Pansexual</option>
                    <option value="Undecided">Undecided</option>
                    <option value="Prefer not to say ">Prefer not to say</option>
                    <option value="Prefer to self-describe">Prefer to self-describe</option>
                    </select>
                    <div style={{ position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                        &#9660;
                    </div>
                </div>
                {errors.sexualOrientation && <Form.Text className="text-danger"> <span className="star">*</span> {errors.sexualOrientation} </Form.Text>}
            </Col>
            <Col sm={12} md={6} className="my-1">
                <h5>Please specify:</h5>
                <Form.Group>
                    <Form.Control
                        value={other.sexualOrientation}
                        maxLength="200"
                        onChange={(e) => {
                            setOther({ ...other, sexualOrientation: e.target.value })
                            setErrors({ ...errors, sexualOrientationOther: '' });
                        }}
                        disabled={sexualOrientation === "Prefer to self-describe" ? false : true}
                        className={errors.sexualOrientationOther ? "form-control is-invalid custom-input" : "form-control custom-input"}
                        type="text" />
                </Form.Group>
                {errors.sexualOrientationOther && <Form.Text className="text-danger"> <span className="star">*</span> {errors.sexualOrientationOther} </Form.Text>}
            </Col>

            <Col sm={12} md={6} className="my-1">
                <h5>What is your religion or belief?:<span className="star">*</span></h5>
                <div style={{ position: 'relative', width: '100%' }}>
                <select
                    id="title-select"
                    name="title"
                    className={errors.religion ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    value={religion}
                    onChange={(e) => {
                        setReligion(e.target.value);
                        setErrors({ ...errors, religion: '' });
                    }}
                >
                    <option value="">-Please Select-</option>
                    <option value="No religion or belief">No religion or belief</option>
                    <option value="Buddhist">Buddhist</option>
                    <option value="Christian">Christian</option>
                    <option value="Hindu">Hindu</option>
                    <option value="Jewish">Jewish</option>
                    <option value="Muslim">Muslim</option>
                    <option value="Sikh">Sikh</option>
                    <option value="Prefer not to say ">Prefer not to say</option>
                    <option value="Other – please specify">Other – please specify</option>
                    </select>
                    <div style={{ position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                        &#9660;
                    </div>
                </div>
                {errors.religion && <Form.Text className="text-danger"> <span className="star">*</span> {errors.religion} </Form.Text>}
            </Col>
            <Col sm={12} md={6} className="my-1">
                <h5>Please specify:</h5>
                <Form.Group>
                    <Form.Control
                        maxLength="500"
                        disabled={religion === "Other – please specify" ? false : true}
                        className={errors.religionOther ? "form-control is-invalid custom-input" : "form-control custom-input"}
                        value={other.religion}
                        onChange={(e) => {
                            setOther({ ...other, religion: e.target.value });
                            setErrors({ ...errors, religionOther: '' });
                        }}
                        type="text" />
                </Form.Group>
                {errors.religionOther && <Form.Text className="text-danger"> <span className="star">*</span> {errors.religionOther} </Form.Text>}
            </Col>


            <Col sm={6} md={12} className="my-0">
                <h2 style={{ textAlign: 'left', fontSize: '18px', marginBottom: '-2px' }}>Data Consent Statement<span className="star">*</span></h2>
                <div style={{ display: "flex", alignItems: "start" }}>
                    <h5 style={{ marginRight: "15px" }}>
                        By selecting <strong>"I agree"</strong>, you confirm that you consent to your Personal Data being processed by FP McCann.
                    </h5>
                </div>
            </Col>

            <Col sm={6} md={1} className="my-0">
                <span>I Agree {'  '}</span>
                <input
                    type="checkbox"
                    style={{ marginRight: "5px", transform: "scale(1.2)" }}
                    onChange={handleDataConsentChange}
                    checked={dataConsent}
                />


            </Col>

            <Row>
                <Col sm={12} className="d-flex justify-content-between mt-3">
                    <Button className="btn-lg btn-shadow" variamt="danger" onClick={handleBackButton}>Back</Button>
                    <Button className="btn-lg-submit btn-shadow" variant="success" disabled={isLoading} onClick={handleSubmitCommand}>Submit Application</Button>
                </Col>
            </Row>

        </Row>
    );
}

export default EqualOpportunitiesMonitoring































{/*<Col sm={12} md={12} className="my-1">*/ }
{/*    <Form.Group className="text-start my-2">*/ }
{/*        <Form.Label style={{ fontWeight: '600', fontSize: '0.99rem' }}>Asian or Asian British:</Form.Label>*/ }
{/*        <div className="radio-buttons-container">*/ }
{/*            <div className="radio-buttons-wrapper">*/ }
{/*                <label className="radio-button">*/ }
{/*                    Indian&nbsp;*/ }
{/*                    <input type="radio" value="Indian" checked={selectedOption === 'Indian'} onChange={handleOptionChange} />*/ }
{/*                    <span className="checkmark"></span>*/ }
{/*                </label>*/ }
{/*                <label className="radio-button">*/ }
{/*                    Pakistani&nbsp;*/ }
{/*                    <input type="radio" value="Pakistani" checked={selectedOption === 'Pakistani'} onChange={handleOptionChange} />*/ }
{/*                    <span className="checkmark"></span>*/ }
{/*                </label>*/ }
{/*                <label className="radio-button">*/ }
{/*                    Bangladeshi&nbsp;*/ }
{/*                    <input type="radio" value="Bangladeshi" checked={selectedOption === 'Bangladeshi'} onChange={handleOptionChange} />*/ }
{/*                    <span className="checkmark"></span>*/ }
{/*                </label>*/ }
{/*                <label className="radio-button">*/ }
{/*                    Chinese&nbsp;*/ }
{/*                    <input type="radio" value="Chinese" checked={selectedOption === 'Chinese'} onChange={handleOptionChange} />*/ }
{/*                    <span className="checkmark"></span>*/ }
{/*                </label>*/ }
{/*            </div>*/ }
{/*        </div>*/ }
{/*    </Form.Group>*/ }

{/*    <Form.Group className="text-start my-2">*/ }
{/*        <Form.Label style={{ fontWeight: '600', fontSize: '0.99rem' }}>Black, African, Caribbean or Black British:</Form.Label>*/ }
{/*        <div className="radio-buttons-container">*/ }
{/*            <div className="radio-buttons-wrapper">*/ }
{/*                <label className="radio-button">*/ }
{/*                    African&nbsp;*/ }
{/*                    <input type="radio" value="African" checked={selectedOption === 'African'} onChange={handleOptionChange} />*/ }
{/*                    <span className="checkmark"></span>*/ }
{/*                </label>*/ }
{/*                <label className="radio-button">*/ }
{/*                    Caribbean&nbsp;*/ }
{/*                    <input type="radio" value="Caribbean" checked={selectedOption === 'Caribbean'} onChange={handleOptionChange} />*/ }
{/*                    <span className="checkmark"></span>*/ }
{/*                </label>*/ }

{/*            </div>*/ }
{/*        </div>*/ }
{/*    </Form.Group>*/ }

{/*    <Form.Group className="text-start my-2">*/ }
{/*        <Form.Label style={{ fontWeight: '600', fontSize: '0.99rem' }}>Mixed or Multiple Ethnic Groups:</Form.Label>*/ }
{/*        <div className="radio-buttons-container">*/ }
{/*            <div className="radio-buttons-wrapper">*/ }
{/*                <label className="radio-button">*/ }
{/*                    White and Black Caribbean&nbsp;*/ }
{/*                    <input type="radio" value="White and Black Caribbean" checked={selectedOption === 'White and Black Caribbean'} onChange={handleOptionChange} />*/ }
{/*                    <span className="checkmark"></span>*/ }
{/*                </label>*/ }
{/*                <label className="radio-button">*/ }
{/*                    White and Black African&nbsp;*/ }
{/*                    <input type="radio" value="White and Black African" checked={selectedOption === 'White and Black African'} onChange={handleOptionChange} />*/ }
{/*                    <span className="checkmark"></span>*/ }
{/*                </label>*/ }
{/*                <label className="radio-button">*/ }
{/*                    White and Asian&nbsp;*/ }
{/*                    <input type="radio" value="White and Asian" checked={selectedOption === 'White and Asian'} onChange={handleOptionChange} />*/ }
{/*                    <span className="checkmark"></span>*/ }
{/*                </label>*/ }
{/*            </div>*/ }
{/*        </div>*/ }
{/*    </Form.Group>*/ }

{/*    <Form.Group className="text-start my-2">*/ }
{/*        <Form.Label style={{ fontWeight: '600', fontSize: '0.99rem' }}>White:</Form.Label>*/ }
{/*        <div className="radio-buttons-container">*/ }
{/*            <div className="radio-buttons-wrapper">*/ }
{/*                <label className="radio-button">*/ }
{/*                    English&nbsp;*/ }
{/*                    <input type="radio" value="English" checked={selectedOption === 'English'} onChange={handleOptionChange} />*/ }
{/*                    <span className="checkmark"></span>*/ }
{/*                </label>*/ }
{/*                <label className="radio-button">*/ }
{/*                    Welsh&nbsp;*/ }
{/*                    <input type="radio" value="Welsh" checked={selectedOption === 'Welsh'} onChange={handleOptionChange} />*/ }
{/*                    <span className="checkmark"></span>*/ }
{/*                </label>*/ }
{/*                <label className="radio-button">*/ }
{/*                    Scottish&nbsp;*/ }
{/*                    <input type="radio" value="Scottish" checked={selectedOption === 'Scottish'} onChange={handleOptionChange} />*/ }
{/*                    <span className="checkmark"></span>*/ }
{/*                </label>*/ }
{/*                <label className="radio-button">*/ }
{/*                    Northern Irish&nbsp;*/ }
{/*                    <input type="radio" value="Northern Irish" checked={selectedOption === 'Northern Irish'} onChange={handleOptionChange} />*/ }
{/*                    <span className="checkmark"></span>*/ }
{/*                </label>*/ }
{/*                <label className="radio-button">*/ }
{/*                    Irish&nbsp;*/ }
{/*                    <input type="radio" value="Irish" checked={selectedOption === 'Irish'} onChange={handleOptionChange} />*/ }
{/*                    <span className="checkmark"></span>*/ }
{/*                </label>*/ }
{/*                <label className="radio-button">*/ }
{/*                    British&nbsp;*/ }
{/*                    <input type="radio" value="British" checked={selectedOption === 'British'} onChange={handleOptionChange} />*/ }
{/*                    <span className="checkmark"></span>*/ }
{/*                </label>*/ }
{/*                <label className="radio-button">*/ }
{/*                    Gypsy or Irish Traveller&nbsp;*/ }
{/*                    <input type="radio" value="Gypsy or Irish Traveller" checked={selectedOption === 'Gypsy or Irish Traveller'} onChange={handleOptionChange} />*/ }
{/*                    <span className="checkmark"></span>*/ }
{/*                </label>*/ }
{/*            </div>*/ }
{/*        </div>*/ }
{/*    </Form.Group>*/ }

{/*    <Form.Group className="text-start my-2">*/ }
{/*        <Form.Label style={{ fontWeight: '600', fontSize: '0.99rem', opactiy: "0.5" }}>Other Ethnic group:</Form.Label>*/ }
{/*        <div className="radio-buttons-container">*/ }
{/*            <div className="radio-buttons-wrapper">*/ }
{/*                <label className="radio-button">*/ }
{/*                    Arab&nbsp;*/ }
{/*                    <input type="radio" value="Arab" checked={selectedOption === 'Arab'} onChange={handleOptionChange} />*/ }
{/*                    <span className="checkmark"></span>*/ }
{/*                </label>*/ }
{/*                <label className="radio-button">*/ }
{/*                    Prefer not to say&nbsp;*/ }
{/*                    <input type="radio" value="Prefer not to say" checked={selectedOption === 'Prefer not to say'} onChange={handleOptionChange} />*/ }
{/*                    <span className="checkmark"></span>*/ }
{/*                </label>*/ }

{/*            </div>*/ }
{/*        </div>*/ }
{/*    </Form.Group>*/ }
{/*</Col>*/ }
{/*</Col>*/ }
